import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Instagram, Send } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-20 md:py-32 bg-brand-black text-white relative overflow-hidden" data-id="element-38">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-brand-charcoal/30 skew-x-12 transform translate-x-1/4 pointer-events-none" data-id="element-39" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-40">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-41">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-42">
            <h2 className="text-4xl md:text-5xl font-display font-bold mb-6" data-id="element-43">
              Talk to Us
            </h2>
            <p className="text-gray-400 text-lg mb-10 leading-relaxed" data-id="element-44">
              Have a question, partnership inquiry, or want to learn more about
              our coffee? We'd love to hear from you.
            </p>

            <div className="space-y-8" data-id="element-45">
              <div className="flex items-start" data-id="element-46">
                <div className="bg-brand-red/10 p-3 rounded-sm mr-4" data-id="element-47">
                  <MapPin className="text-brand-red w-6 h-6" data-id="element-48" />
                </div>
                <div data-id="element-49">
                  <h4 className="font-display font-bold text-lg mb-1" data-id="element-50">
                    Location
                  </h4>
                  <p className="text-gray-400" data-id="element-51">Trans Nzoia, Kenya</p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-52">
                <div className="bg-brand-red/10 p-3 rounded-sm mr-4" data-id="element-53">
                  <Phone className="text-brand-red w-6 h-6" data-id="element-54" />
                </div>
                <div data-id="element-55">
                  <h4 className="font-display font-bold text-lg mb-1" data-id="element-56">Phone</h4>
                  <p className="text-gray-400" data-id="element-57">+254 743 287 924</p>
                  <p className="text-gray-400" data-id="element-58">+254 720 250 0850</p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-59">
                <div className="bg-brand-red/10 p-3 rounded-sm mr-4" data-id="element-60">
                  <Mail className="text-brand-red w-6 h-6" data-id="element-61" />
                </div>
                <div data-id="element-62">
                  <h4 className="font-display font-bold text-lg mb-1" data-id="element-63">Email</h4>
                  <a href="mailto:blazinbarryscoffee@gmail.com" className="text-gray-400 hover:text-white transition-colors" data-id="element-64">
                    blazinbarryscoffee@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start" data-id="element-65">
                <div className="bg-brand-red/10 p-3 rounded-sm mr-4" data-id="element-66">
                  <Instagram className="text-brand-red w-6 h-6" data-id="element-67" />
                </div>
                <div data-id="element-68">
                  <h4 className="font-display font-bold text-lg mb-1" data-id="element-69">
                    Social
                  </h4>
                  <a href="https://instagram.com/blazingbarryscoffee" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-70">
                    @blazingbarryscoffee
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-white p-8 md:p-10 rounded-sm shadow-2xl" data-id="element-71">
            <h3 className="text-2xl font-display font-bold text-brand-black mb-6" data-id="element-72">
              Get in Touch
            </h3>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-73">
              <div data-id="element-74">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-75">
                  Name
                </label>
                <input type="text" id="name" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-sm focus:ring-2 focus:ring-brand-red focus:border-transparent outline-none transition-all text-brand-black" placeholder="Your Name" data-id="element-76" />
              </div>
              <div data-id="element-77">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-78">
                  Email
                </label>
                <input type="email" id="email" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-sm focus:ring-2 focus:ring-brand-red focus:border-transparent outline-none transition-all text-brand-black" placeholder="your@email.com" data-id="element-79" />
              </div>
              <div data-id="element-80">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-81">
                  Message
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-sm focus:ring-2 focus:ring-brand-red focus:border-transparent outline-none transition-all text-brand-black resize-none" placeholder="How can we help you?" data-id="element-82"></textarea>
              </div>
              <button type="submit" className="w-full bg-brand-red text-white font-display font-bold uppercase tracking-wider py-4 rounded-sm hover:bg-red-700 transition-colors flex items-center justify-center group" data-id="element-83">
                Send Message
                <Send className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-84" />
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}